// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_i3P","cls2":"PaperClaiming-cls2_jsk PaperClaiming-cls1_i3P"};